import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-wallet-02',
  standalone: true,
  templateUrl: '../../assets/wallet-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamWallet02Icon {}
